import i18next from 'i18next'

export default (hydrate = value => value) =>
  value => {
    const hydratedValue = hydrate(value)
    if (!hydratedValue) {
      return {
        isValid: false,
        message: i18next.t('is required'),
      }
    }
  }
